module.exports = __webpack_public_path__ + "images/2bc51da4a9aba77b5c298ba87364cb99-favicon-96x96.png";